<template>
    <div v-bind:class="['video-container video_orientation_' + orientation, {'video-body-horizontal-less' : maxWidth < 100 && orientation === 'horizontal' }]">
        <div id="video-layout" class="video-layout video-layout-grid"
             v-bind:class="[{ 'video-layout-horizontal' : orientation === 'horizontal' }, { 'video-layout-vertical' : orientation === 'vertical' }]"
             :style="checkBackgroundColor">
            <div id="side-left" class="side-left-grid"></div>
            <div id="video-orientation"
                 v-bind:class="[video_body_class + ' video-orientation-grid']">
                <div v-bind:class="video_body_container_vPlayer_class">
                    <div id="container-video-body" class="container-video-body" style="position: relative;">
                        <video-player
                            :options="videoOptions"
                            :video_layout_class="video_layout_class"
                            :playerReady="playerReady"
                            v-if="!isFetching"/>
                        <thumbnail-base
                            v-if="!isFetching"></thumbnail-base>
                        <hotspot-base
                            v-if="!isFetching"></hotspot-base>
                        <control-overlay-base
                            v-if="!isFetching"></control-overlay-base>
                        <console-base
                            v-if="!isFetching"
                        :currentTimePlayer="currentTimePlayer"></console-base>
                        <unmute-autoplay
                            v-if="!isFetchingBtnUnmuteAutoplay"></unmute-autoplay>
                        <control-bar
                            ref="controlBar"
                            v-if="!isFetching"
                            :currentTimePlayer="currentTimePlayer"></control-bar>
                        <lightbox-base
                            v-if="!isFetching"></lightbox-base>
                        <share-base
                            v-if="!isFetching"></share-base>
                        <sidebar-full-base :hasFrame="hasFrame"
                                           v-if="!isFetching"></sidebar-full-base>
                        <form-base
                            v-if="!isFetching"></form-base>
                    </div>
                    <sidebar-base :hasFrame="hasFrame"
                                  v-if="!isFetching"></sidebar-base>
                </div>
            </div>
            <div id="side-right" class="side-right-grid"></div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { fetchSettings } from "@/playerVue3/services/video-service";
import { usePlayerStore } from '@/playerVue3/storage/storePlayer';
import VideoPlayer from '@/playerVue3/components/video-player.vue';
import ThumbnailBase from '@/playerVue3/components/thumbnail-base.vue';
import HotspotBase from '@/playerVue3/components/hotspot-base.vue';
import ControlOverlayBase from '@/playerVue3/components/control-overlay-base.vue';
import ConsoleBase from '@/playerVue3/components/console-base.vue';
import ControlBar from '@/playerVue3/components/controlbar/control-bar.vue';
import LightboxBase from '@/playerVue3/components/lightbox-base.vue';
import ShareBase from '@/playerVue3/components/sidebar/components/share-base.vue';
import SidebarBase from '@/playerVue3/components/sidebar-base.vue';
import SidebarFullBase from '@/playerVue3/components/sidebar-full-base.vue';
import FormBase from '@/playerVue3/components/form-base.vue';
import UnmuteAutoplay from '@/playerVue3/components/controlbar/unmute-autoplay.vue';
import { firstInteraction } from "@/playerVue3/services/analytic-service";

// INITIALIZE STORE & COMPOSABLES
const store = usePlayerStore();

// PROPS
const props = defineProps({
    backgroundColor: {
        type: String,
        default: '',
    },
    maxWidth: {
        type: Number,
        default: 100,
    },
});

// REACTIVE VARIABLES
const bar_control_overlay = ref('bar-control-overlay-horizontal');
const playerRef = ref(null);
const isFetching = ref(true);
const isFetchingHotspot = ref(true);
const orientation = ref('horizontal');
const overlay_layout_coordinate = ref(store.getOverlayLayoutCoordinates);
const overlay_layout_class = ref('overlay-layout-horizontal');
const video_layout_class = ref('video-layout-horizontal');
const video_body_class = ref('video-body-horizontal');
const video_body_container_vPlayer_class = ref('video-body-horizontal-container-vPlayer');
const videoOptions = ref({
    src: '',
    title: '',
    description: '',
    orientationClass: '',
    fps: 0,
});
const windowIsResized = ref(false);

// COMPUTED PROPERTIES
const checkBackgroundColor = computed(() => {
    if (props.backgroundColor != '') {
        //return 'background-color: ' + store.getBackgroundColor + ';';
        return 'background-color: ' + props.backgroundColor + ';';
    } else {
        return '';
    }
});
const currentTimePlayer = computed(() => {
    return store.getCurrentTimePlayer;
});
const hasFrame = computed(() => {
    return store.getHasFrame;
});
const isFetchingBtnUnmuteAutoplay = computed(() => {
    return store.getIsFetchingBtnUnmuteAutoplay;
});
const playerReady = computed(() => {
    if (store.getPlayerIsReady && isFetchingHotspot.value) {
        overlay_layout_coordinate.value = store.getOverlayLayoutCoordinates;
        changeCoordinates();
        isFetchingHotspot.value = false;
    }
    return store.getPlayerIsReady;
});

// METHODS
const changeCoordinates = () => {
    const varConsoleOverlay = document.getElementById("console-overlay");
    varConsoleOverlay.style.left = overlay_layout_coordinate.value.left + 'px';
    const consoleOverlayHeight = overlay_layout_coordinate.value.height - 48;
    varConsoleOverlay.style.height = consoleOverlayHeight + 'px';
    varConsoleOverlay.style.width = overlay_layout_coordinate.value.width + 'px';

    const varConsoleOverlayBody = document.getElementById("console-body");
    varConsoleOverlayBody.style.height = consoleOverlayHeight - (consoleOverlayHeight - ((consoleOverlayHeight * 87) / 100)) + 'px';

    const hotspotOverlay = document.getElementById("hotspot-overlay");
    hotspotOverlay.style.left = overlay_layout_coordinate.value.left + 'px';
    hotspotOverlay.style.height = '100%';
    hotspotOverlay.style.width = '100%';

    //let addWidth = 0;
    const hasFrame = document.querySelector('#videoPlayerContainer').dataset.hasframe;
    const containerLightbox = document.getElementById("containerLightbox");
    containerLightbox.style.left = overlay_layout_coordinate.value.left + 'px';
    containerLightbox.style.height = '100%';
    containerLightbox.style.width = '100%';

    const thumbnailOverlay = document.getElementById("thumbnail-overlay");
    thumbnailOverlay.style.left = overlay_layout_coordinate.value.left + 'px';
    thumbnailOverlay.style.height = '100%';
    thumbnailOverlay.style.width = '100%';

    const containerVideoBody = document.getElementById("container-video-body");
    containerVideoBody.style.left = overlay_layout_coordinate.value.left + 'px';
    containerVideoBody.style.height = '100%';

    const videoOverlayControl = document.getElementById("video-overlay-control");
    videoOverlayControl.style.left = overlay_layout_coordinate.value.left + 'px';
    videoOverlayControl.style.height = '100%';
    videoOverlayControl.style.width = '100%';

    if (store.getSidebar.length > 0 && store.getVideoOrientation === 'vertical') {
        const videoBodyVertical = document.getElementById("video-orientation");
        videoBodyVertical.style.width = (9 / 16) * 105 + 'vh';
    }

    const videoLayout = document.getElementById("video-layout");
    const sideLeft = document.getElementById("side-left");
    sideLeft.style.height = videoLayout.offsetHeight + 'px';
    const sideRight = document.getElementById("side-right");
    sideRight.style.height = videoLayout.offsetHeight + 'px';
};

const imagePath = () => {
    return store.getPathLocalOrServer;
};

const resizeOverlayLayout = () => {
    windowIsResized.value = true;
    const varVideoTag = document.getElementById("videoTag");
    overlay_layout_coordinate.value.height = varVideoTag.offsetHeight;
    overlay_layout_coordinate.value.width = varVideoTag.offsetWidth;
    overlay_layout_coordinate.value.top = varVideoTag.offsetTop;
    overlay_layout_coordinate.value.left = varVideoTag.offsetLeft;
    changeCoordinates();
    windowIsResized.value = false;
};

const searchVideoSettings = async () => {
    const videoContainer = document.querySelector('#videoPlayerContainer');
    store.setVideoID(parseInt(videoContainer.dataset.vid));
    store.setEmail(parseInt(videoContainer.dataset.email));
    store.setWeblinkID(parseInt(videoContainer.dataset.wid));
    store.setWeblinkIDEncore(videoContainer.dataset.widenc);
    store.setIsDebug(videoContainer.dataset.debug);
    store.setModeAdmin(parseInt(videoContainer.dataset.modeadmin));
    store.setHasFrame(videoContainer.dataset.hasframe);
    orientation.value = videoContainer.dataset.orientation;

    let response = {};
    response = await fetchSettings(parseInt(videoContainer.dataset.vid), parseInt(videoContainer.dataset.wid), videoContainer.dataset.email);
    if (response) {
        store.initializeFromSettings(response.data)

      if (!store.registerHotspotData) {
        // generamos la analitica solo si no hay formulario de registro
        // todo: esta funcion llama a attachWindowEvents y no tengo claro si esta ultima si debe seguirse llamando
        // al principio....
        // por el momento, tiene sentido que attachWindowEvents siga sincronizado con firstInteraction
        await firstInteraction(store);
      }

        if (store.getVideoData.videoType === 'Vimeo') {
            videoOptions.value.src = store.getVideoData.videoVimeo;
        } else {
            videoOptions.value.src = imagePath() + "videos/files_hls/" + store.getVideoData.videoSrcHls;
        }
        videoOptions.value.title = store.getVideoData.title;
        videoOptions.value.description = store.getVideoData.description;
        videoOrientation();
        videoOptions.value.orientationClass = video_layout_class.value;
        videoOptions.value.fps = Number(store.getVideoData.fps);

        return true;
    }
    return false;
};

const videoOrientation = () => {
    const videoData = store.getVideoData;
    if (videoData.videoWidth < videoData.videoHeight) {
        video_layout_class.value = 'video-layout-vertical';
        video_body_class.value = 'video-body-vertical';
        video_body_container_vPlayer_class.value = 'video-body-vertical-container-vPlayer';
        overlay_layout_class.value = 'overlay-layout-vertical';
        bar_control_overlay.value = 'bar-control-overlay-vertical';

        store.setVideoOrientation('vertical');
    }
};

// LYFECYCLE HOOKS
onMounted(async () => {
    let response = false;
    response = await searchVideoSettings();
    if (response) {
        videoOrientation();
        isFetching.value = false;
    }

    window.addEventListener("resize", resizeOverlayLayout);
});

onUnmounted(() => {
    window.removeEventListener("resize", resizeOverlayLayout);
});
</script>
